import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth';
import { MemberStore } from '../../store/member/member.store';

export const memberOnboardingAccessGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router)
  const authService = inject(AuthService)
  const memberStore = inject(MemberStore)

  const memberId = Number(memberStore.id())
  
  if(memberId > 0) {
    return true
  }

  try {
    await memberStore.getMember()

    if(!memberStore.active()) {
      return router.createUrlTree(['/member/onboarding']);
    }

    return true
  } catch(err) {
console.error('Error fetching member data:', err);
  } 
  return true
};
